import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import Match from "../../components/Match";
import {
    makeSelectFullMatchById,
    selectMatchById,
} from "../../../selectors";
import { MatchSmallElement } from "../../../config/types";
import { mapToMatchSmall } from "../../../config/utils";
import { allowedViews, type View, pathMatchView, pathHome } from "../../../config/routes";


const isAllowedView = (v?: string): v is View =>
    !!v && allowedViews.includes(v as View);

const MatchPage: React.FC = () => {
    const { matchId: matchIdParam, view: viewParam } = useParams<{
        matchId?: string;
        view?: string;
    }>();

    const matchId = React.useMemo(() => {
        const n = matchIdParam ? parseInt(matchIdParam, 10) : NaN;
        return Number.isFinite(n) ? n : undefined;
    }, [matchIdParam]);

    const view: View | undefined = React.useMemo(
        () => (isAllowedView(viewParam) ? (viewParam as View) : undefined),
        [viewParam]
    );


  const smallSelector = React.useMemo(
    () => (matchId != null ? selectMatchById(matchId) : undefined),
    [matchId]
  );
  const fullSelector = React.useMemo(
    () => (matchId != null ? makeSelectFullMatchById(matchId) : undefined),
    [matchId]
  );

    const matchFromSmall = useSelector((s: RootState) =>
        smallSelector ? smallSelector(s) : undefined
    );
    const matchFull = useSelector((s: RootState) =>
        fullSelector ? fullSelector(s) : undefined
    );

    const match: MatchSmallElement | undefined = React.useMemo(() => {
        if (matchFromSmall) return matchFromSmall;
        if (matchFull) return mapToMatchSmall(matchFull, matchFull.league);
        return undefined;
    }, [matchFromSmall, matchFull]);

    if (typeof matchId !== "number") {
        return <Navigate to={pathHome()} replace />;
    }

    if (!view) {
        return <Navigate to={pathMatchView(matchId, "highlights")} replace />;
    }

    return <Match match={match} currentView={view} />;
};

export default MatchPage;
